import { Account } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const accountAdapter: EntityAdapter<Account> = createEntityAdapter<Account>({
	selectId: account => account.id
});